import { render, staticRenderFns } from "./TestimonialItem.vue?vue&type=template&id=5c878831&"
import script from "./TestimonialItem.vue?vue&type=script&lang=js&"
export * from "./TestimonialItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports